/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response from mass email campaign start
 * @export
 * @interface MassEmailCampaignResponse
 */
export interface MassEmailCampaignResponse {
    /**
     * Temporal workflow ID for tracking and signals
     * @type {string}
     * @memberof MassEmailCampaignResponse
     */
    workflowId?: string;
    /**
     * Whether the workflow was started successfully
     * @type {boolean}
     * @memberof MassEmailCampaignResponse
     */
    success?: boolean;
    /**
     * Error message if success is false
     * @type {string}
     * @memberof MassEmailCampaignResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the MassEmailCampaignResponse interface.
 */
export function instanceOfMassEmailCampaignResponse(value: object): value is MassEmailCampaignResponse {
    return true;
}

export function MassEmailCampaignResponseFromJSON(json: any): MassEmailCampaignResponse {
    return MassEmailCampaignResponseFromJSONTyped(json, false);
}

export function MassEmailCampaignResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MassEmailCampaignResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowId': json['workflowId'] == null ? undefined : json['workflowId'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function MassEmailCampaignResponseToJSON(json: any): MassEmailCampaignResponse {
    return MassEmailCampaignResponseToJSONTyped(json, false);
}

export function MassEmailCampaignResponseToJSONTyped(value?: MassEmailCampaignResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workflowId': value['workflowId'],
        'success': value['success'],
        'error': value['error'],
    };
}

